import React from "react"
import { AktualnoosciBox, ElementsSlider, Opis, Slider1 } from "./rootComp"
import Gallery from "./gallery"
import { AktualnoscFullBox } from "./aktualonosciFullBox";

const s = "To była nie tylko sportowa przygoda, alaaaaae też fantastyczny czas spędzony razem – w trasie, w hotelu i przede wszystkim na lodzie. Droga była długa, ale pełna śmiechu, energii i dobrej zabawy – złapaliśmy kilka fajnych momentów w trasie, które chcemy Wam pokazać. Na lodzie? PTH Koziołki zostawiły kawał serducha – zagraliśmy mecze pełne emocji, pokazaliśmy charakter i świetną drużynową chemię. To była nie tylko sportowa przygoda, ale też fantastyczny czas spędzony razem – w trasie, w hotelu i przede wszystkim na lodzie.Droga była długa, ale pełna śmiechu, energii i dobrej zabawy – złapaliśmy kilka fajnych momentów w trasie, które chcemy Wam pokazać. Na lodzie? PTH Koziołki🐺 zostawiły kawał serducha – zagraliśmy mecze pełne emocji, pokazaliśmy charakter i świetną drużynową chemię. To była nie tylko sportowa przygoda, ale też fantastyczny czas spędzony razem – w trasie, w hotelu i przede wszystkim na lodzie.";

export const AktualnosciPage = () => {
    return (
        <>


            <AktualnoscFullBox />


        </>
    )
}